import uuid from 'uuid-random';

import { addPopupAction } from '@core/js/components/common/PopupManager';

import { DuplicateAccountPopup } from './DuplicateAccountPopup';

export const showDuplicateAccountPopupAction = () =>
    addPopupAction({
        id: uuid(),
        component: DuplicateAccountPopup,
        layer: 'HIGH_PRIORITY'
    });
